import { COLLECTIVITY_ROUTE, FARMER_ROUTE } from "@utils/Routes";
import { ReactComponent as FarmerImage } from "src/static/images/farmer.svg";
import { ReactComponent as CollectivityImage } from "src/static/images/collectivity.svg";
import { ReactComponent as FarmerImageMobile } from "src/static/images/farmer-small.svg";
import { ReactComponent as CollectivityImageMobile } from "src/static/images/collectivity-small.svg";

export const HOME_MENU = [
  {
    key: "farmer",
    link: FARMER_ROUTE,
    icon: <FarmerImage aria-hidden="true" focusable="false" />,
    iconMobile: <FarmerImageMobile aria-hidden="true" focusable="false" />,
    title: "home.cards.farmer.title",
    subtitle: "home.cards.farmer.subtitle",
    actionLabel: "home.cards.farmer.action",
  },
  {
    key: "collectivity",
    link: COLLECTIVITY_ROUTE,
    icon: <CollectivityImage aria-hidden="true" focusable="false" />,
    iconMobile: (
      <CollectivityImageMobile aria-hidden="true" focusable="false" />
    ),
    title: "home.cards.collectivity.title",
    subtitle: "home.cards.collectivity.subtitle",
    actionLabel: "home.cards.collectivity.action",
  },
] as {
  key: string;
  link: string;
  icon: JSX.Element;
  iconMobile: JSX.Element;
  title: string;
  subtitle: string;
  actionLabel: string;
}[];
